import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { torneosSlice } from './slices/torneosSlice'

const useTorneosStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    datos: {
        id:0,
        nombre:"",
        imagen:"",
        descripcion:"",
        reglas:"",
        detalle:"",
        hexFondo:"#FFFFFF",
        hexTexto:"#000000",
        sucursales:[],
        estatus:"draft",
        fechaInicio:"",
        fechaFin:"",
        fechaInicioInscripcion:"",
        fechaFinInscripcion:"",
        tipoTorneo:"team",
        genero:"open",
        formato:"single_elimination",
        aprobacion:"automatic",
        maxJugadores:"",
        categoriaInicio:"",
        categoriaFin:"",
        costo:"0",
        instruccionesPago:"",
    },
    fileImagen: null,
    imagen:"",
    setHexFondo: (hex) => set({datos:{ ...get().datos, hexFondo: hex }}),
    setHexTexto: (hex) => set({datos:{ ...get().datos, hexTexto: hex }}),
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    handleImagen: (e) => set({ imagen: e.target.files.base64, fileImagen: e.target.files.originalFile, datos:{ ...get().datos, imagen: e.target.files.originalFile.name } }),
    limpiarImagen: () => set({ imagen: "", fileImagen: null, datos:{ ...get().datos, imagen: "" } }),
    handleSave: () => get().insertarTorneo(),
    handleSucursales: (e) => set({ datos: { ...get().datos, sucursales: e ? [e] : [] } }),
    iniciar: async() => {
        await get().obtenerSucursales();
        if ((get().datos.sucursales || []).length === 0 && get().sucursales.length > 0) {
            set({ datos: { ...get().datos, sucursales: [get().sucursales[0]] } });
        }
        await get().obtenerTorneo();
        set({ isLoading: false });
    },
    limpiar: () => {
        set({
            isLoading: true,
            datos: {
                id:0,
                nombre:"",
                descripcion:"",
                reglas:"",
                detalle:"",
                hexFondo:"#FFFFFF",
                hexTexto:"#000000",
                sucursales:[],
                estatus:"draft",
                fechaInicio:"",
                fechaFin:"",
                fechaInicioInscripcion:"",
                fechaFinInscripcion:"",
                tipoTorneo:"team",
                genero:"open",
                formato:"single_elimination",
                aprobacion:"automatic",
                maxJugadores:"",
                categoriaInicio:"",
                categoriaFin:"",
                costo:"0",
                instruccionesPago:"",
            },
            fileImagen: null,
            imagen:"",
            elNavigate:null,
            error:null,
        })
    },
    ...formularioSlice(set,get),
    ...sucursalesSlice(set,get),
    ...torneosSlice(set,get)
}))
  
export default useTorneosStore
